import { render, staticRenderFns } from "./editClientView.vue?vue&type=template&id=7b8701a5&"
import script from "./editClientView.vue?vue&type=script&lang=js&"
export * from "./editClientView.vue?vue&type=script&lang=js&"
import style0 from "./editClientView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports